import { DueDateType } from '../db/types';
import { dateTimeDiff, unix } from './datetime';

export interface CommentsContainer {
  comments: {
    total: number;
    seen: number;
  };
}

export interface ActivityStatsContainer extends CommentsContainer {
  total: number;
  seen: number;
  closed?: number;
  pending?: number;
  published?: number;
  completed?: number;
}

export function getIsManuallyClosedActivity<
  T extends {
    preferences: {
      dueDateType: DueDateType;
    };
  },
>(activity: T) {
  return activity.preferences.dueDateType === DueDateType.MANUAL;
}

export function getIsActivityPublished<T extends { publishedOn: UnixTime | undefined }>(activity: T) {
  if (!activity.publishedOn) return false;
  return activity.publishedOn > 0;
}

export const getTotalComments = <T extends CommentsContainer>(state: T) => state.comments.total;
export const getSeenComments = <T extends CommentsContainer>(state: T) => state.comments.seen;

export const getUnseenComments = <T extends CommentsContainer>(state: T) => {
  return Math.max(0, getTotalComments(state) - getSeenComments(state));
};

export function getIsDeadlinePast(deadline: UnixTime) {
  return deadline < unix();
}

export function getIsDeadlineNear(endTimestamp: UnixTime) {
  const hoursToEndTime = dateTimeDiff(endTimestamp, unix(), 'hours');
  return hoursToEndTime >= 0 && hoursToEndTime <= 24;
}
